import { AmbientWorldEventKind, ambientWorldCatalog, parseAmbientWorldEventKind, type AmbientWorldEventKind as AmbientWorldEventKindType } from './fishing-world-catalog'

export type FishingWorldDebugSimulation = Readonly<{
  id: string
  kind: AmbientWorldEventKindType
  label: string
  presentation?: Readonly<{ badgerSide?: 'left' | 'right' }>
}>

export const FISHING_WORLD_EVENT_LABELS: Readonly<Record<AmbientWorldEventKindType, string>> = {
  [AmbientWorldEventKind.Birds]: 'Птицы: перелёты',
  [AmbientWorldEventKind.DistantSparrowFlock]: 'Птицы: дальняя стая',
  [AmbientWorldEventKind.FishJump]: 'Всплеск рыбы',
  [AmbientWorldEventKind.Badger]: 'Барсук',
  [AmbientWorldEventKind.Nessie]: 'Несси',
  [AmbientWorldEventKind.Dragonfly]: 'Стрекоза',
  [AmbientWorldEventKind.DistantHeron]: 'Далёкая цапля',
  [AmbientWorldEventKind.ReedsRipple]: 'Рябь в камышах',
  [AmbientWorldEventKind.FrogCall]: 'Лягушачий зов',
  [AmbientWorldEventKind.OtterWake]: 'След выдры',
  [AmbientWorldEventKind.WeatherLightningSilhouette]: 'Силуэт молнии',
  [AmbientWorldEventKind.BeetleOnSign]: 'Жук на табличке',
  [AmbientWorldEventKind.ButterflyOnBucket]: 'Бабочка на ведре',
  [AmbientWorldEventKind.ButterflyOnSign]: 'Бабочка на табличке',
  [AmbientWorldEventKind.DragonflyOnDockPost]: 'Стрекоза на причале',
  [AmbientWorldEventKind.LadybugOnSignSupport]: 'Божья коровка на стойке',
  [AmbientWorldEventKind.FrogInForegroundStones]: 'Лягушка у камней',
}

/** Development-only commands deliberately resolve through catalog identities. */
export const fishingWorldDebugSimulations = [
  { id: 'birds-flights', kind: AmbientWorldEventKind.Birds, label: 'Птицы: перелёты' },
  { id: 'birds-murmuration', kind: AmbientWorldEventKind.DistantSparrowFlock, label: 'Птицы: дальняя стая' },
  { id: 'badger-left', kind: AmbientWorldEventKind.Badger, label: 'Симулировать: барсук слева', presentation: { badgerSide: 'left' } },
  { id: 'badger-right', kind: AmbientWorldEventKind.Badger, label: 'Симулировать: барсук справа', presentation: { badgerSide: 'right' } },
  { id: 'fish-jump', kind: AmbientWorldEventKind.FishJump, label: 'Симулировать: всплеск рыбы' },
  { id: 'nessie', kind: AmbientWorldEventKind.Nessie, label: 'Симулировать: Несси' },
  { id: 'beetle-on-sign', kind: AmbientWorldEventKind.BeetleOnSign, label: 'Жук на табличке' },
  { id: 'butterfly-on-bucket', kind: AmbientWorldEventKind.ButterflyOnBucket, label: 'Бабочка на ведре' },
  { id: 'butterfly-on-sign', kind: AmbientWorldEventKind.ButterflyOnSign, label: 'Бабочка на табличке' },
  { id: 'dragonfly-on-dock-post', kind: AmbientWorldEventKind.DragonflyOnDockPost, label: 'Стрекоза на причале' },
  { id: 'ladybug-on-sign-support', kind: AmbientWorldEventKind.LadybugOnSignSupport, label: 'Божья коровка на стойке' },
  { id: 'frog-in-foreground-stones', kind: AmbientWorldEventKind.FrogInForegroundStones, label: 'Лягушка у камней' },
] as const satisfies readonly FishingWorldDebugSimulation[]

export function isFishingWorldDebugEnabled(environment = process.env.NODE_ENV): boolean {
  return environment !== 'production'
}

export function parseFishingWorldDebugSimulation(value: unknown): FishingWorldDebugSimulation | null {
  if (typeof value !== 'string') return null
  return fishingWorldDebugSimulations.find((simulation) => simulation.id === value) ?? null
}

export function isEnabledFishingWorldDebugSimulation(simulation: FishingWorldDebugSimulation): boolean {
  return parseAmbientWorldEventKind(simulation.kind) !== null && ambientWorldCatalog[simulation.kind].enabled
}
